<div class="wrapper {{ this.class }}">
  <div class="icon-wrapper">
    <ion-icon class="{{ this.class }}" [name]="this.icon"></ion-icon>
  </div>
  <div class="information-text">
    <ng-content></ng-content>
  </div>
</div>
